import verificationDictionary_2 from '@widgets/verification_2/i18n/ru/verification_2.dic.json';

export const verification_2 = {
  VERIFICATION_2: verificationDictionary_2,
};

export const verificationNamespaces_2 = Object.keys(verification_2);
